import { CSpinner } from "@coreui/react";
import { requester } from "App";
import Container from "layouts/container/Container";
import { useEffect, useState } from "react";
import style from "./StoreManagement.module.css";
import StoreManagementDetail from "./StoreManagementDetail";

function StoreManagement() {
    const [storeList, setStoreList] = useState();

    useEffect(() => {
        // requester.findAllStores((result) => {
        //     console.log(result.data);
        //     setStoreList(result.data);
        // })
        requester.findAllByConfirmYnIsTrue((result) => {
            console.log("findAllByConfirmYnIsTrue : ",result.data);
            setStoreList(result.data);
        })
    }, [])

    return (
        
            <div className={style.container}>
                <div className={style.flexGrid}>
                    {storeList ? storeList.map((store) => (
                        <div className={style.flexBox} key={store.id}>
                            <div className={style.card}>
                                <StoreManagementDetail data={store} />
                            </div>
                        </div>
                    )) : (
                        <div className={style.loaderContainer}>
                            <CSpinner color="primary" />
                        </div>
                    )}
                </div>
            </div>
        
    );
}

export default StoreManagement;